"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const breakpoints = {
  BREAKPOINTS: {
    SMALL: 0,
    MEDIUM: 768,
    LARGE: 1024,
    X_LARGE: 1440
  },
  DEVICES: {
    SMALL: 'SM',
    MEDIUM: 'MD',
    LARGE: 'LG',
    X_LARGE: 'XL'
  }
};
var _default = exports.default = breakpoints;